/* eslint-disable @bibliocommons/bibliocommons/dataKey */
import PropTypes from 'prop-types';
import React from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';
import { withRouter } from '@bibliocommons/utils-routing';
import { routerShape } from '@bibliocommons/bc-prop-types';

function BibSeries({ series, router }) {
  if (series && !series.isEmpty()) {
    const name = series.get('name');
    const volume = series.get('volume');
    return (
      <span className="cp-bib-series">
        <Link
          to={router.createHref({
            pathname: '/v2/search',
            query: { query: name, searchType: 'series' }
          })}
        >
          <FormattedMessage id="seriesLabel" values={{ name }} />
        </Link>
        {volume ? ` - ${volume}` : null}
      </span>
    );
  }
  return null;
}

BibSeries.displayName = 'BibSeries';
BibSeries.propTypes = {
  series: ImmutablePropTypes.mapContains({
    name: PropTypes.string,
    volumeNumber: PropTypes.number
  }),
  router: routerShape.isRequired
};

export default withRouter(BibSeries);
